import { render, staticRenderFns } from "./OrderSetupDialog.vue?vue&type=template&id=2372f73a&scoped=true&"
import script from "./OrderSetupDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderSetupDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OrderSetupDialog.vue?vue&type=style&index=0&id=2372f73a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2372f73a",
  null
  
)

export default component.exports